'use strict'

import Vue from 'vue'
import axios from 'axios'

import 'nprogress/nprogress.css'
import NProgress from 'nprogress' // progress bar

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.baseURL = 'https://us-central1-farmerspace-techfarm.cloudfunctions.net/api'
process.env.NODE_ENV === 'production'
  ? (axios.defaults.baseURL = 'https://asia-east2-farmerspace-techfarm.cloudfunctions.net/api')
  : (axios.defaults.baseURL = 'http://localhost:3000')
let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ''
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    NProgress.start()
    return config
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    NProgress.done()
    return response
  },
  function(error) {
    // Do something with response error
    NProgress.done()
    return Promise.reject(error)
  }
)

Plugin.install = function(Vue) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios
      }
    },
    $axios: {
      get() {
        return _axios
      }
    }
  })
}

Vue.use(Plugin)

export default Plugin
